import type { Contacts } from "@/src/gql/graphql";
import { ENHANCED_CONTACTS_CONFIG } from "@/features/contacts/components/EnhancedContactsConfig";
import { ENHANCED_CONTACT_DETAIL_CONFIG } from "@/features/contacts/components/ContactDetailConfig";
import { useContactsConfigEnhancer } from "@/lib/hooks/api/shared/config-enhancers";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// CONTACTS ENTITY DEFINITION
// ============================================================================
// Single source of truth for all contacts UI configuration.
// Column change: edit tableConfig.fields or features/contacts/config/*.
// Detail page change: edit detailConfig or features/contacts/config/contact-detail-*.
// New saved view: add to tableConfig.savedViews (features/contacts/config/contact-saved-views.ts).
// Custom filter hook: add to tableConfig.customFilterHooks (same file).
// ============================================================================

export const contactsEntity = defineEntity<Contacts>({
  tableConfig: ENHANCED_CONTACTS_CONFIG as any,

  detailConfig: ENHANCED_CONTACT_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },

  // Injects dynamic tag options into tableConfig.fields.tags at render time
  useConfigEnhancer: (config) => useContactsConfigEnhancer({ config: config as any }),
});
